module.exports = __webpack_public_path__ + "static/media/hydro_dapp_store_logo.b73e8cdb.png";